import { icons } from '@images';

export function OnboardingGreeting(): React.JSX.Element {
  return (
    <div className="flex flex-col items-center gap-2 text-center">
      <div className="flex items-center gap-3">
        <img src={icons.MyraAiBetaIcon} alt="myra.AI beta" className="mt-[14px] h-[48px]" />
        <p className="font-ivypresto text-primary text-[42px] leading-[56px] font-normal tracking-wide">
          Your AI Assistant for Flights & Stays
        </p>
      </div>
      <p className="font-avenir text-[18px] leading-[24px]">
        <span className="font-medium text-[#4a4a4a]">
          Converse with Myra to book flights and stays effortlessly
        </span>
      </p>
    </div>
  );
}
